<template>
  <div v-if="readyToDisplayAgreement && formField">
    <component
      :is="component"
      :formField="formField"
      :licenseName="licenseName"
      :specification="specification"
    />
  </div>
</template>

<script>
export default {
  props: {
    component: {
      type: Object,
      required: true,
    },
    licenseName: {
      type: String,
      required: true,
    },
  },
  computed: {
    agreement() {
      return this.$store.state.agreement;
    },
    specification() {
      return this.agreement.specification;
    },
    readyToDisplayAgreement() {
      return !!this.specification;
    },
    formField() {
      if (!this.readyToDisplayAgreement) return null;

      const license = this.agreement.specification[this.licenseName];
      const licenseActions = license.sequence.filter(sequenceName => this.agreement.action[sequenceName]);

      return licenseActions
        .reduce((acc, actionName) => {
          const action = this.agreement.action[actionName];

          // Do nothing if itemFormName doesn't exist
          if (!action.itemFormName) return acc;

          // Fill itemForm with default value is necessary
          const prefilledValue = action.items
            .filter(({ itemAction }) => !!itemAction)
            .reduce(
              (existingPrefill, { itemAction }) => {
                switch (itemAction.inputValuePrefilled) {
                  case 'TRUE':
                  case 'true':
                    return true;
                  case 'FALSE':
                  case 'false':
                    return false;
                  case null:
                  case undefined:
                    return existingPrefill;
                  default:
                    return itemAction.inputValuePrefilled;
                }
              }
              , undefined
            )
          ;

          acc[actionName] = {
            key: action.itemFormName,
            value: prefilledValue,
          };
          return acc;
        }, {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Licenses/CommonLicenseComponents/Wrapper.vue